import { render, staticRenderFns } from "./ServicesLaunchpadVision.vue?vue&type=template&id=2d2941bc&scoped=true"
import script from "./ServicesLaunchpadVision.vue?vue&type=script&lang=js"
export * from "./ServicesLaunchpadVision.vue?vue&type=script&lang=js"
import style0 from "./ServicesLaunchpadVision.vue?vue&type=style&index=0&id=2d2941bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d2941bc",
  null
  
)

export default component.exports